import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { useSelector, useDispatch } from 'react-redux';
import { hideEldDialog } from '../../redux/actions/dialogActions.js';
import { clearDate, setComment, setDate, setHour, setModule, setWpl } from '../../redux/actions/logActions.js';
import { dictionary } from '../../dictionary.js';
import DialogOverlay from './DialogOverlay.js';

const EldComponent = (props) => {
  const dispatch = useDispatch();
  const dialogProps = props.dialogProps;
  const [eldSorted, setEldSorted] = useState(null);
  const toast = useRef(null);
  const dateLog = new Date(useSelector((state) => state.date.value));
  const moduleLog = useSelector((state) => state.module.value);
  const hourLog = useSelector((state) => state.hours.value);
  const wplLog = useSelector((state) => state.wpl.value);
  const commentLog = useSelector((state) => state.comment.value);

  useEffect(() => {
    if (dialogProps.eldData[0].length !== 0) {
      setEldSorted(dialogProps.sortData(dialogProps.eldData[0].eld));
    }
  }, [dialogProps]);

  const showMsg = () => {
    toast.current.show({
      severity: 'warn',
      summary: dictionary.toast_summary_warn,
      detail: dictionary.toast_create_log_detail,
      life: 7000,
    });
  };

  return (
    <>
      <Dialog
        header={dictionary.eld_dialog_header}
        visible={dialogProps.isDialogOpen}
        style={{ width: '50vw' }}
        onHide={() => {
          dialogProps.setValuesOnInitialState();
          dialogProps.setShowOverlay(true);
          dispatch(hideEldDialog());
        }}
      >
        <Toast ref={toast} />
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_date}</label>
          {dialogProps.showOverlay && <DialogOverlay dialogProps={dialogProps} />}
          <Calendar
            disabledDays={dialogProps.disabledDays}
            style={{ width: '100%' }}
            placeholder={dateLog}
            value={dateLog}
            onChange={(e) => {
              if (dialogProps.checkIfDayIsPlanned(e.value)) {
                dispatch(setDate(e.value));
                dialogProps.setShowOverlay(false);
              } else {
                showMsg();
                dispatch(clearDate());
              }
            }}
            showIcon
            dateFormat="dd/mm/yy"
          />
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_module}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={moduleLog}
            options={eldSorted}
            filter
            filterInputAutoFocus
            onChange={(e) => {
              dispatch(setModule(e.value.name));
            }}
            optionLabel="name"
            placeholder={moduleLog !== null ? moduleLog : dictionary.dialog_placeholder_module}
            className={moduleLog === null && dialogProps.formSubmitted ? 'p-invalid' : null}
          />
          {moduleLog === null && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_module}</small>
          ) : null}
        </div>
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_hours}</label>
          <Dropdown
            style={{ width: '100%' }}
            value={hourLog}
            options={dialogProps.eldData[0].hours}
            filter
            filterInputAutoFocus
            onChange={(e) => {
              dispatch(setHour(e.value.hour));
            }}
            optionLabel="hour"
            placeholder={
              hourLog !== null && hourLog !== undefined ? String(hourLog) : dictionary.dialog_placeholder_hours
            }
            className={(hourLog === null || hourLog === undefined) && dialogProps.formSubmitted ? 'p-invalid' : null}
          />
          {(hourLog === null || hourLog === undefined) && dialogProps.formSubmitted ? (
            <small className="p-error">{dictionary.dialog_error_hours}</small>
          ) : null}
        </div>
        {dialogProps.postEditing ? (
          <div className="field field-wrapper">
            <label>{dictionary.dialog_label_wpl}</label>
            <Dropdown
              style={{ width: '100%' }}
              value={wplLog}
              options={dialogProps.wplArr}
              onChange={(e) => {
                dispatch(setWpl(e.value.name));
              }}
              optionLabel="name"
              placeholder={wplLog !== 0 ? wplLog : dictionary.dialog_placeholder_wpl}
              className={wplLog === 0 && dialogProps.formSubmitted ? 'p-invalid' : null}
            />
            {wplLog === 0 && dialogProps.formSubmitted ? (
              <small className="p-error">{dictionary.dialog_error_wpl}</small>
            ) : null}
          </div>
        ) : null}
        <div className="field field-wrapper">
          <label>{dictionary.dialog_label_comment}</label>
          <InputText
            style={{ width: '100%' }}
            value={commentLog !== null ? commentLog : ''}
            placeholder={dictionary.dialog_placeholder_comment}
            onChange={(e) => {
              dispatch(setComment(e.target.value));
            }}
          />
        </div>
        <div className="field field-wrapper">
          {!dialogProps.postEditing ? (
            <Button
              label={dictionary.dialog_save_btn}
              icon="pi pi-save"
              className="field-report-btn"
              onClick={() => {
                dialogProps.setFormSubbmited(true);
                dialogProps.setShowOverlay(true);
                if (moduleLog !== null && hourLog !== null && hourLog !== undefined) {
                  dialogProps.onLogSave();
                }
              }}
            />
          ) : (
            <Button
              label={dictionary.dialog_update_btn}
              icon="pi pi-save"
              className="field-report-btn"
              onClick={() => {
                dialogProps.setFormSubbmited(true);
                dialogProps.setShowOverlay(true);
                if (moduleLog !== null && hourLog !== null && hourLog !== undefined) {
                  dialogProps.onRowEditComplete();
                }
              }}
            />
          )}
        </div>
      </Dialog>
    </>
  );
};

export default EldComponent;
